import React, { useState } from 'react';
import logo from "./Alayaa.png";
import AxiosClient from '../assets/AxiosClient';
import { useStateContext } from '../Contexts/ContextProvider';
import Loader from '../assets/tools/Loder/loader';
import styles from './Login.module.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { setToken, setUser } = useStateContext();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await AxiosClient.post('login', { email, password });
      if (response.status === 200) {
        setUser(response.data.user);
        setToken(response.data.token);
        // Redirect logic (e.g., useNavigate)
      }
    } catch (err) {
      setError('Invalid email or password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`${styles.loginContainer} d-flex align-items-center justify-content-center min-vh-100`}>
      <div className="col-lg-5 col-md-8 col-12">
        <div className={`${styles.card} card shadow-lg border-0`}>
          <div className="card-header text-center pt-5 bg-transparent border-0">
            <img src={logo} alt="Al-Alia Logo" className={`${styles.logo} mb-3`} />
            <h4 className="fw-bold mt-2">Welcome Back</h4>
            <p className="mb-0 text-muted small">
              Sign in to manage conference attendance
            </p>
          </div>

          <div className="card-body px-4 pt-0 pb-4">
            {error && (
              <div className={`${styles.alert} alert alert-danger alert-dismissible fade show d-flex align-items-center`} role="alert">
                <i className="fas fa-exclamation-circle me-2"></i>
                <span>{error}</span>
                <button
                  type="button"
                  className="btn-close ms-auto"
                  onClick={() => setError('')}
                  aria-label="Close"
                />
              </div>
            )}

            <form onSubmit={handleSubmit} role="form">
              <div className={`${styles.inputGroup} mt-4`}>
                <input
                  type="email"
                  className={`${styles.input} form-control`}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="Email address"
                />
              </div>

              <div className={`${styles.inputGroup} mt-4 position-relative`}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  className={`${styles.input} form-control`}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="Password"
                />
                <button
                  type="button"
                  className={`${styles.togglePassword} btn btn-link p-0 position-absolute end-0 top-50 translate-middle-y me-2`}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'} text-secondary`} />
                </button>
              </div>

              <div className="text-center mt-4">
                <button
                  type="submit"
                  className={`${styles.submitBtn} btn w-100`}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                      Signing in...
                    </>
                  ) : (
                    'Sign In'
                  )}
                </button>
              </div>
            </form>
          </div>

          <div className="card-footer text-center pt-0 border-0 bg-transparent pb-4">
            <p className="text-muted small mb-0">
              Al-Alia · Conference Attendance Management
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;